import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";

const TablePosition = (props) => {
  const { offset } = props;
  const start = offset + 1;
  const end = offset + props.rowsOnPage;
  if (props.totalRows > 0) {
    return (
      <div className="table-position">
        <FormattedMessage id="datatable.position.results" />{" "}
        <span>{start}</span>-<span>{end}</span> (<span>{props.totalRows}</span>{" "}
        <FormattedMessage id="datatable.position.total" />)
      </div>
    );
  }
  return null;
};

TablePosition.propTypes = {
  offset: PropTypes.number.isRequired,
  style: PropTypes.object,
  totalRows: PropTypes.number.isRequired,
  rowsOnPage: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number,
};

export default TablePosition;



// WEBPACK FOOTER //
// ./src/components/common/DataTable/TablePosition.js